import { pubsub } from './pubsub';

// creates the form inputs to add a project
export function addProject() {
	const addProjectButton = document.querySelector('.add-project-button');
	addProjectButton.addEventListener('click', () => {
		const projectModal = document.createElement('dialog');
		projectModal.classList.add('project-dialog-element');
		projectModal.dataset.projectDialogElement = true;
			// modal heading
		const projectModalHeading = document.createElement('div');
		projectModalHeading.innerText = 'Project name (max. 30ch):';
			// form element
		const projectForm = document.createElement('form');
		projectForm.classList.add('add-project-form');
		projectForm.dataset.addProjectForm = true;
		projectForm.addEventListener('submit', submitAddedProject);

		const projectFormInput = document.createElement('input');
		projectFormInput.classList.add('project-form-input');
		projectFormInput.dataset.projectFormInput = true;
		projectFormInput.type = 'text';
		projectFormInput.name = 'textInput';
		projectFormInput.maxLength = 30;
		projectFormInput.required = true;
			// submit button
		const submitButton = document.createElement('button');
		submitButton.classList.add('project-submit-button');
		submitButton.type = 'submit';
		submitButton.innerText = 'Submit';

		// cancel button
		const cancelButton = document.createElement('button');
		cancelButton.classList.add('project-cancel-button');
		cancelButton.type = 'button';
		cancelButton.textContent = 'Cancel';
		cancelButton.addEventListener('click', cancelAddingProject);

			// appending the input, button, form, heading to the modal
		projectForm.appendChild(projectFormInput);
		projectForm.appendChild(submitButton);
		projectForm.appendChild(cancelButton);
		projectModal.appendChild(projectModalHeading);
		projectModal.appendChild(projectForm);
		document.body.appendChild(projectModal);

		// open the modal
		projectModal.showModal();
	});
}

// submits info for newly added project
function submitAddedProject(event) {
	// slecting DOM elements
	const projectModal = document.querySelector('[data-project-dialog-element]');
	const projectFormInput = document.querySelector('[data-project-form-input]');

	// preventing the default action for the 'Submit' button
	event.preventDefault();

	// getting the input value and
	// publishing an event with this value to local storage
	const projectName = projectFormInput.value;
	pubsub.publish('projectAdded', projectName);

	// resetting the form, closing the modal, and removing it from the DOM
	this.reset();
	projectModal.close();
	projectModal.remove();
}

function cancelAddingProject() {
	const addProjectModal = document.querySelector('.project-dialog-element');
	addProjectModal.close();
	addProjectModal.remove();
}
